import { createBrowserRouter, Navigate } from 'react-router-dom';
import { App } from '../App';
import { AuthGuard } from '../components/AuthGuard';
import { AppDownloadPage } from '../pages/AppDownloadPage/AppDownloadPage';
// cycle 1-18 항목3 — 라우트 레벨 role 가드 (admin 경로 진입 차단).
import { RoleGuard } from '../components/RoleGuard';
import { HrGrantGuard } from '../components/HrGrantGuard';
import { LoginPage } from '../pages/LoginPage';
import { MfaVerifyPage } from '../pages/MfaVerifyPage';
// 2차 인증 **등록** (2026-08-25) — 관리자 권한을 새로 받은 사람이 지나는 자리.
//   이 화면이 없어서 그동안 로그인 화면으로 조용히 튕겼다(MfaEnrollPage.tsx 머리말).
import { MfaEnrollPage } from '../pages/MfaEnrollPage';
// oss-notices — 배포본을 받은 사람은 로그인 없이도 고지를 볼 수 있어야 한다. AuthGuard 외부.
import { OssLicensesPage } from '../pages/OssLicensesPage';
// cycle 96 — 로그인 연동(초기 계정 활성화). AuthGuard 외부(로그인 전 진입).
import { ActivatePage } from '../pages/ActivatePage';
// FE-W-03 — Onboarding wizard (회사 셀프 가입). AuthGuard 외부 — 로그인 안 한 사용자 진입.
import {
  OnboardingWizard,
  OnboardingExpiredPage,
  OnboardingRaceRejectedPage,
  OnboardingPendingApprovalPage,
} from '../pages/OnboardingWizard';
// Step 컴포넌트 — FE-W-04~07 모두 정식 컴포넌트로 교체.
import { Step1CompanyForm } from '../pages/OnboardingWizard/steps/Step1CompanyForm';
import { Step2DomainForm } from '../pages/OnboardingWizard/steps/Step2DomainForm';
import { Step3DomainVerifyPanel } from '../pages/OnboardingWizard/steps/Step3DomainVerifyPanel';
import { Step4AdminAccount } from '../pages/OnboardingWizard/steps/Step4AdminAccount';
import { ChatPage } from '../pages/ChatPage';
// ★ 작성은 이제 `MailPage` 가 셸 안에서 그린다(2026-09-08) — 라우터가 따로 부르지 않는다.
import { MailPage } from '../pages/MailPage';
import { ContactsPage } from '../pages/ContactsPage';
// AI (설계 판 A, 2026-09-09) — 셸이 트리를 이고 자식이 화면이다(근태·인사와 같은 꼴).
import { AiShell } from '../pages/AiPage/AiShell';
import { AiChatPage } from '../pages/AiPage/AiChatPage';
import { AiAgentsPage } from '../pages/AiPage/AiAgentsPage';
import { AiAutomationsPage } from '../pages/AiPage/AiAutomationsPage';
import { AiAgentFormPage } from '../pages/AiPage/AiAgentFormPage';
import { AiAutomationFormPage } from '../pages/AiPage/AiAutomationFormPage';
import { CalendarPage } from '../pages/CalendarPage';
import { TaskPage } from '../pages/TaskPage';
// project-menu-detailing (2026-06-10) — /project 대시보드 메뉴.
// v2 드릴다운 — 통계 카드 상세 화면 (adr-20260610-0409).
//   ⛔ 2026-10-12 사용자 결정 ⇒ 「1. /project/stats 삭제해라 화면도 필요없다.」
//     ⇒ 넷 중 통계(StatsDetailPage)를 걷었다 ⇒ 남은 셋이다.
//     ⚠ 정본(feature/dev-syk)에는 그 화면이 «있다» — ⛔ 정본에 맞추려고 되살리지 말 것.
import {
  ProjectPage, TeamsDetailPage, ProjectsDetailPage, MyTasksDetailPage,
  ProjectSearchPage, ProjectNavShell,
} from '../pages/ProjectPage';
import { ProjectV2Route } from '../pages/ProjectV2';
// 2026-10-09 (2차 4-5) — 「내 업무」 보드. 다른 v2 화면들과 같은 꼴로 «그 파일에서» 바로 가져온다.
import { MyTasksBoard } from '../pages/ProjectV2/MyTasksBoard';
/*
 * ⚠ 통(`../pages/ProjectV2`)이 아니라 ★ «파일»에서 바로 가져온다.
 *   까닭: 관제가 이 판에 `M` 을 ★ 셋으로 묶었다(project-i18n · 이 파일 · Favorites/index).
 *   ⇒ 통에 export 를 더하면 ⛔ 넷째 `M` 이 된다. ⇒ ⭐ 3차에서 묶을지는 ★ 그때 정한다.
 */
import { SpaceV2Page } from '../pages/ProjectV2/SpaceV2Page';
import { SpaceV2Fallback } from '../pages/ProjectV2/SpaceV2Fallback';
import { ChecklistTemplatesV2Page } from '../pages/ProjectV2/ChecklistTemplatesV2Page';
// 예약 (2026-08-12) — 부모 셸 + 하위 3화면. 레지스트리에는 부모 1행(menu_key='reservation')만 있고
// 하위 메뉴는 ReservationPage 의 ② 좌측 서브 네비가 담당한다(레지스트리에 2-depth 개념 없음).
import {
  ReservationPage, ReservationBookPage, MyReservationsPage, ReservationApprovalPage,
} from '../pages/ReservationPage';
import { WorkspacePage } from '../pages/WorkspacePage';
// 근태 0단계 (2026-08-23) — 입사일 일괄(화면 C) · 연차 관리(화면 O). ADMIN 전용.
//   경로를 `/erp` 아래에 둔다 — 근태는 `/hr`(복원 금지) 이 아니라 **새 경로**로 연다는 결정을
//   따른다. 메뉴(레지스트리 `attendance`)는 1단계에서 붙으므로 지금은 주소로만 들어간다.
import {
  HireDatesPage, LeaveQuotaPage, WorkSchedulePage, EmployeesPage, CompanyHolidayPage, OrgLeaderPage,
  TeamAttendancePage, DutyPage, WagePage, AnomaliesPage, LeavePolicyPage, LeavePromotionPage, LeaveSettlementPage, ShiftRosterPage,
  // 휴일대체 (2026-09-06 · 판 B) — 보상휴가 §57.
  SubstitutePolicyPage,
  // 근태 셸 (2026-08-29 · 판 A)
  AttShell,
} from '../pages/AttendancePage';
import { MyAttendanceHistoryPage } from '../pages/AttendancePage/MyAttendanceHistoryPage';
// 근태 › 사용자 관리 (2026-08-25) — 관리 콘솔(8444)의 사용자 관리 화면을 복사해 온 것.
//   위 묶음 import 를 건드리지 않도록 한 줄로 따로 받는다(기존 라인 보존).
import { UserManagePage } from '../pages/AttendancePage/UserManagePage';
// 인사 셸 (2026-08-26) — 위 화면들을 «인사» 트리 하나로 묶는다. 화면 자체는 그대로다.
import {
  HrShell, HrIndex, HrStatsPage, RecordsPage, AwardsPage, EvaluationsPage, TrainingsPage, MyRecordCardPage, ProfileRequestsPage, AccessLogPage, JobGradesPage, JobRolesPage, TeamHrPage, StaffPage, StaffCardPage, MyCertificatePage, CertificateAdminPage, AssignmentPage, OffboardingPage,
  EmployeesListPage, EmployeeDetailPage, EmployeeHirePage, EmployeeCardPage,
} from '../pages/HrMenu';
// 결재함 (2026-09-13 · 과제 L1) — 시안 axi-approval-status v2.
import { ApprovalBoxPage } from '../pages/ApprovalPage/box/ApprovalBoxPage';
// 옛 문서함 주소 넷 → 결재함 마디 (2026-09-13 · 과제 L2) — 시험이 같은 표를 본다.
import { LEGACY_BOX_REDIRECTS } from '../pages/ApprovalPage/box/approval-box-types';
import { LegacyBoxRedirect } from '../pages/ApprovalPage/box/LegacyBoxRedirect';

import { DashboardPage } from '../pages/DashboardPage';
import { SettingsPage } from '../pages/SettingsPage';
// 통합설정 › 사업장 상세 (2026-09-14 · v3) — 메뉴는 그대로, 본문만 상세.
import { WorksiteDetailRoute } from '../pages/SettingsPage/worksites/WorksiteDetailRoute';
// 내 프로필 화면은 없앴다(2026-09-07) — 주소만 남아 설정을 연다. MyProfileMoved 머리말 참조.
import { MyProfileMoved } from '../pages/MyProfilePage';
import { BoardPage } from '../pages/BoardPage';
// 다중 게시판 (migration 102, 2026-08-18). /info(BoardPage)는 그대로 둔다 —
//   메뉴에서만 빠졌고 화면·API 는 보존한다(사용자 결정).
import { BoardsPageSwitch } from '../pages/BoardsPage';
// 게시판 시안 v1 — 화면별 주소 (2026-09-15 · 결정 Q5). 플래그가 꺼져 있으면 쓰이지 않는다.
import { boardV1Route } from '../pages/BoardV1';
import { BOARD_V1_ENABLED } from '../lib/layout-shell';
// AI 회의록 (additive) — minutes-svc(:4103) 연동. 메뉴는 8444 메뉴관리에서 /menu-config 로 동적 노출.
import { AiMinutesPage } from '../pages/AiMinutesPage';
// 내 근태 (2026-08-23, 근태 1단계) — 화면 D·E. 메뉴(레지스트리 `attendance`)는 아직 없어
//   주소로만 들어간다. 경로를 `/erp` 아래에 두는 것은 "근태는 /hr 이 아니라 새 경로로 연다"
//   는 결정을 따른 것이다.
import { MyAttendancePage } from '../pages/AttendancePage/MyAttendancePage';
// 기준 설정 (2026-08-28 · 자리 재정의 판 7) — 회사가 정하는 «값». 근태·인사가 같은 화면을
//   도메인만 달리해 쓴다(휴가 종류는 근태, 고용형태는 인사).
import { AttendanceCodesPage, HrCodesPage } from '../pages/CodesPage';
import { DocTypePage } from '../pages/ApprovalPage/DocTypePage';
// 인사(HRPage) 옛 경로 `/hr` 라우트는 사용자 결정으로 의도적 비노출 — 아래 children 참조.
// 급여(PayrollPage)는 2026-09-13 사용자 결정으로 복원됐다(아래 `path: 'payroll'`).
import { PayrollPage } from '../pages/PayrollPage';
// ★ 2026-08-24 — **전자결재(/approval)는 연다.** 2026-08-23 결정 ①(근태 2차 설계): 근태의 휴가·
//   연장·정정·외근·출장이 전부 결재를 타고, 지출결의서·품의서까지 이 라우트 뒤에 있었다.
//   페이지와 백엔드는 처음부터 살아 있었고 **라우트 등록만 빠져 있었다**.
//   ⚠ `/hr` 의 복원 금지는 그대로다 — 근태는 새 경로 `/erp` 로 연다.
// 조직도(OrganizationPage)는 2026-07-24 사용자 지시로 노출 전환(좌측 바 하단 메뉴).
import { OrganizationPage } from '../pages/OrganizationPage';
/**
 * 전자결재 — 2026-08-24 결정 ① 로 라우트를 열었고, 2026-08-31 에 **셸이 생겼다.**
 *
 * ★★ 종전에는 `/approval` 한 주소가 사이드바 · 문서함 셋 · 관리 화면 넷을 **제 상태로만**
 *    갈아 끼웠다. 그래서 어느 함도 북마크할 수 없었고, 트리 생김새도 인사·근태와 달랐다.
 *    이제 근태(`AttShell`)·인사(`HrShell`)와 **같은 꼴**이다 — 셸이 트리를 이고 자식이 화면이다.
 */
import { ApprShell } from '../pages/ApprovalPage/ApprShell';
import { ApprovalDocPage } from '../pages/ApprovalPage/ApprovalDocPage';
import { ApprovalBoxesPage } from '../pages/ApprovalPage/ApprovalBoxesPage';
import { ApprovalDocsPage } from '../pages/ApprovalPage/ApprovalDocsPage';
import { ApprovalHome } from '../pages/ApprovalPage/ApprovalHome';
// 기안 — **창이 아니라 자리** (2026-08-31 · 시안 「기안하는 자리」).
import { ApprovalNewPage } from '../pages/ApprovalPage/ApprovalNewPage';
import { BriefingPage } from '../pages/BriefingPage/BriefingPage';
import { ApprovalStatsPage } from '../pages/ApprovalPage/ApprovalStatsPage';
import { ApprovalLinesAdmin } from '../pages/ApprovalPage/ApprovalLinesAdmin';
import { DelegatePage } from '../pages/ApprovalPage/DelegatePage';
import { ApprovalCodesPage } from '../pages/CodesPage';
// 지출 집행 (2026-09-04 · 예산 판 B1) — **주소가 자격을 정한다**(내 것 · 회사 전체가 다른 길).
import { MyExpenseClaimsPage, CompanyExpenseClaimsPage } from '../pages/ApprovalPage/ExpenseClaimsPage';
// 예산 편성 (2026-09-04 · 예산 판 B2) — 편성 − 집행 = 잔액, 신청중을 빼면 가용.
import { BudgetPage } from '../pages/ApprovalPage/BudgetPage';
import { HelpPage, AdminBulkImportHelp } from '../pages/HelpPage';
import { HelpHome } from '../pages/HelpPage/HelpHome';
// Cycle 6 §4 — Service Admin (SYSTEM_ADMIN) tenant 관리.
import { SystemAdminPage } from '../pages/SystemAdminPage/SystemAdminPage';
// Cycle 7 — Tenant Detail (unfreeze + quota 편집)
import { TenantDetailPage } from '../pages/SystemAdminPage/TenantDetailPage';
// Cycle 10 — Audit Dashboard (admin_override 시계열)
import { AuditDashboardPage } from '../pages/SystemAdminPage/AuditDashboardPage';
// Cycle 20 — AI Gateway Config (env summary GUI)
import { AiGatewayConfigPage } from '../pages/SystemAdminPage/AiGatewayConfigPage';
// Cycle 23 — Drift opt-out overview
import { DriftOptOutDashboardPage } from '../pages/SystemAdminPage/DriftOptOutDashboardPage';
import { PagePlaceholder } from './placeholders';
import { TeamScopePage } from '../pages/TeamScopePage';
// Admin Console 는 별도 관리 서버(8444)로 분리됨 (adr-20260601-0440). 본 앱에서 제거.

/**
 * 라우트 SSOT — docs/design/component-tree-workchat-v1.md.
 *
 * Phase 1 P1-22: LoginPagePlaceholder → LoginPage 정식 교체.
 * /auth/mfa-verify 추가 — ADMIN MFA 흐름의 두 번째 단계.
 *
 * /login·/auth/mfa-verify 는 AuthGuard 외부 (인증 안 된 사용자 진입).
 * MfaVerifyPage 는 navigate state 의 mfa-pending temp_token 을 직접 검증.
 */
export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    // cycle 96 — 로그인 연동(초기 계정 활성화). AuthGuard 외부.
    path: '/activate',
    element: <ActivatePage />,
  },
  {
    path: '/auth/mfa-verify',
    element: <MfaVerifyPage />,
  },
  {
    // AuthGuard 밖이다 — 아직 정식 세션이 없다(mfa-pending 토큰만 있다).
    path: '/auth/mfa-enroll',
    element: <MfaEnrollPage />,
  },
  {
    // oss-notices (2026-07-10) — 오픈소스 라이선스 고지. 공개 라우트(로그인 불필요).
    path: '/oss-licenses',
    element: <OssLicensesPage />,
  },
  // FE-W-03 — /signup 진입 (LoginPage 의 "회사 가입" 버튼 target) → /onboarding 으로 redirect.
  {
    path: '/signup',
    element: <Navigate to="/onboarding" replace />,
  },
  // FE-W-03 — onboarding wizard. AuthGuard 외부. Step 4 통과 후 finalize 가 auth cookie 발급.
  {
    path: '/onboarding',
    element: <OnboardingWizard />,
    children: [
      { index: true, element: <Step1CompanyForm /> },
      { path: 'domain', element: <Step2DomainForm /> },
      { path: 'verify', element: <Step3DomainVerifyPanel /> },
      { path: 'admin', element: <Step4AdminAccount /> },
      { path: 'expired', element: <OnboardingExpiredPage /> },
      { path: 'race-rejected', element: <OnboardingRaceRejectedPage /> },
      { path: 'pending-approval', element: <OnboardingPendingApprovalPage /> },  // Cycle 72
    ],
  },
  /**
   * 앱 받기 — 휴대폰 화면 (2026-09-14 · 설정 › 다운로드 QR 이 가리키는 곳).
   * ★ 로그인 필요(사용자 결정) — AuthGuard 가 로그인 뒤 이 주소로 돌려보낸다(state.from).
   * ★ 앱 셸(레일 · 메뉴) 밖에 둔다 — 휴대폰 폭 한 장이다.
   */
  {
    path: '/app/download/:platform',
    element: (
      <AuthGuard>
        <AppDownloadPage />
      </AuthGuard>
    ),
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <App />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <PagePlaceholder title="홈" subtitle="대시보드로 이동합니다" redirectTo="/dashboard" /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'chat',      element: <ChatPage /> },
      { path: 'mail',      element: <MailPage /> },
      // 주소록 (migration 171, 2026-09-08) — 메일 다음 칸의 최상위 메뉴.
      { path: 'contacts', element: <ContactsPage /> },
      /**
       * AI (설계 판 A, 2026-09-09) — 우측 AI 패널의 「전체」가 오는 전면 화면이자
       * ① 좌측 레일의 새 메뉴다. 셸이 240 트리를 이고 자식이 화면이다.
       *
       * ★ 가드를 두지 않는다 — AI 는 전 직원의 것이고, 무엇을 읽을 수 있는가는
       *   도구가 **호출자 명의로** 도메인 API 를 부를 때 서버가 판정한다.
       * ★ 자식은 「대화」와 「에이전트」(판 E)다. 업무자동화(판 X)는 갈 곳이 생길 때 줄을 늘린다.
       * ★★ 에이전트 폼은 **주소를 갖는다** — 긴 글을 적는 화면이라 모달이 아니고(결재 기안과
       *    같은 판단), 주소가 있어야 「나가기 전에 묻는」 규칙(정본 P13)이 걸린다.
       */
      {
        path: 'ai',
        element: <AiShell />,
        children: [
          { index: true, element: <AiChatPage /> },
          { path: 'agents', element: <AiAgentsPage /> },
          { path: 'agents/new', element: <AiAgentFormPage /> },
          { path: 'agents/:id', element: <AiAgentFormPage /> },
          /* 업무자동화(판 X1) — 목록과 폼이 한 화면이라 주소가 하나다. */
          { path: 'automations', element: <AiAutomationsPage /> },
          /* 에이전트와 같은 결 — 긴 글을 적는 화면은 주소를 갖고, 그래야 정본 P13 이 걸린다. */
          { path: 'automations/new', element: <AiAutomationFormPage /> },
          { path: 'automations/:id', element: <AiAutomationFormPage /> },
        ],
      },
      /**
       * 메일 작성 (2026-08-22 → 2026-09-08 **셸 안으로**).
       *
       * 답장·전달·내게 쓰기도 모두 여기로 온다 — 쓰는 자리가 둘이면 한쪽만 고쳐지는 날이 온다.
       *
       * ★★★ **좌측 메일함을 덮지 않는다** (2026-09-08 사용자 지시). 여태 제 화면이라
       *    쓰기를 누르면 **메일함이 통째로 사라졌다**. 환경설정과 **같은 판단** — 작성은
       *    제 화면이 아니라 메일 셸의 **오른쪽 칸**이다. 그래서 `MailPage` 가 이 주소도 받는다.
       *    주소는 그대로라 링크 · 새로고침 · 뒤로가기 · `?to=me` 는 지금까지와 똑같다.
       */
      { path: 'mail/compose', element: <MailPage /> },
      /**
       * 메일 환경설정 (2026-09-05) — 좌측 「내 저장용량」 위의 그 메뉴가 온다.
       *
       * ★ **같은 `MailPage` 가 받는다.** 환경설정은 제 화면이 아니라 메일 셸의 **오른쪽 칸**이라
       *   좌측 메일함이 그대로 서 있어야 한다(사용자 지시). 주소를 따로 두는 이유는 쓰기와 같다 —
       *   링크로 열 수 있고, 탭이 `?tab=` 에 남고, 뒤로가기가 듣는다.
       */
      { path: 'mail/settings', element: <MailPage /> },
      { path: 'calendar',  element: <CalendarPage /> },
      /**
       * 우리 조직 (2026-08-28 · 자리 재정의 판 5) — 팀장·부서장·대표가 자기 범위를 보는 자리.
       * ★ **가드가 없다**: 조직에서 그 자리를 맡았는지는 **서버가 판정한다**(`/users/me` 의
       *   `orgScope`). 라우터는 그것을 모르고, 아니면 화면이 스스로 「지정하면 보입니다」로 접힌다.
       */
      { path: 'team', element: <TeamScopePage /> },
      { path: 'task',      element: <TaskPage /> },
      // project-menu-detailing (2026-06-10) — 프로젝트 대시보드.
      { path: 'project',   element: <ProjectPage /> },
      // v2 드릴다운 (2026-06-10) — 통계 카드 → 상세 화면 3종 (추가만, adr-20260610-0409).
      //   ⛔ 2026-10-12 — 종전 「4종」. 통계를 걷어 셋이다(사용자 결정).
      /*
       * ⭐ 2026-09-30 — 네 화면에도 «프로젝트 메뉴»(좌측 2차 네비)를 둔다.
       *   ⛔ 종전에는 /project 에만 있어서, [내 할일] 을 누르면 그 메뉴가 «사라졌다».
       *   ★ 화면 파일은 한 줄도 안 고친다 — 여기서 감싸기만 한다.
       *   ⚠ flush: TeamsDetailPage 만 스스로 높이를 꽉 채우고 스크롤도 직접 다룬다
       *     (.pj-page--shell). 그때 바깥이 여백·스크롤을 또 주면 «안쪽이 잘린다».
       */
      // 2026-10-13 정본 맞춤 — active={null}: 이 화면 가운데 칸이 이미 스페이스 목록이라 좌측 목록은 접어서 연다
      //   (정본 TeamsDetailPage 가 페이지 안에서 `<ProjectNavShell active={null} flush>` 로 감쌌다).
      { path: 'project/teams',    element: <ProjectNavShell active={null} flush><TeamsDetailPage /></ProjectNavShell> },
      { path: 'project/projects', element: <ProjectNavShell><ProjectsDetailPage /></ProjectNavShell> },
      /*
       * ⭐⭐⭐ 2026-10-09 (2차 4-5) — ★ 「내 업무」가 ⇒ ⭐ 깃발 뒤에서 ★ «정본 보드»가 된다.
       *
       * ## ⭐ 옛 줄은 ★ «글자 그대로» 살아 있다 — ⇒ ⛔ 지운 것이 아니다
       * ```
       * 종전  { path: 'project/my-tasks', element: <ProjectNavShell><MyTasksDetailPage /></ProjectNavShell> },
       *                                           └──────────── ★ 이것이 ⭐ 아래 `fallback` 이다 ────┘
       * ⇒ ★ 즉 ⭐ 깃발이 «꺼지면» ⇒ ⇒ ★ 종전과 ⭐ 글자까지 같은 것이 그려진다 (#2310 이 세운 길)
       * ```
       *
       * ## ⚠⚠ 왜 ★ `ProjectNavShell` 이 ⇒ ⭐ «바깥»이 아니라 ★ `fallback` «안»인가
       * ```
       * ⇒ ★ 정본 보드가 ⭐ «자기 셸»을 그린다 — MyTasksBoard.tsx :639 `<ProjectNavShell active="my-tasks">`
       *   ⇒ ⇒ ⛔ 라우터가 또 감싸면 ⇒ ★ 셸이 ⭐ «두 겹»이 된다(메뉴가 두 벌 그려진다)
       * ⇒ ⭐ 정본 라우터도 ★ 그래서 안 감쌌다 ⇒ `{ path: 'project/my-tasks', element: <MyTasksBoard /> }`
       * ⇒ ⇒ ✅ 그래서 ★ «꺼진 쪽만» 감싼다 ⇒ ⇒ ★ 두 길이 ⭐ 각각 셸을 ★ «한 벌씩» 갖는다
       * ⇒ ⚠ 그리고 ★ `ProjectNavShell.test.tsx` 의 ⭐ 「하위 화면은 전부 감싸인다」는 ★ 이 덩어리의
       *   ⭐ «글자»에 `ProjectNavShell` 이 있나를 본다 ⇒ ⇒ ✅ 있다. ★ 뜻도 지켜진다(둘 다 메뉴가 보인다).
       *   ⇒ ⇒ ⛔ 다만 그 시험의 ★ 덩어리 «자르개»가 ⇒ ⭐ `fallback={…}` 의 중괄호에 ★ 걸렸다
       *     ⇒ ⇒ ★ 그래서 그 자르개를 ⭐ «괄호 균형»으로 고쳤다(그 파일에 까닭을 적었다).
       * ```
       * ⇒ ⚠ `active="my-tasks"` 를 ★ 바깥에서 주지 ⛔ 않는다 — ⇒ 그러면 ⭐ «꺼진 쪽»의 메뉴 상태가
       *   ★ 함께 바뀌어 ⇒ ⇒ ⛔ 「꺼진 길은 한 글자도 안 바뀐다」가 깨진다.
       */
      {
        path: 'project/my-tasks',
        element: <ProjectV2Route fallback={<ProjectNavShell><MyTasksDetailPage /></ProjectNavShell>}><MyTasksBoard /></ProjectV2Route>,
      },
      // ⛔ 2026-10-12 — project/stats 라우트를 걷었다(사용자 결정 ⇒ 「화면도 필요없다」).
      //   ⚠ 되살아나지 않게 project-stats-removed.guard.test.ts 가 잠근다.
      // 2026-10-07 — 통합 검색 결과(사용자 결정 ㉠-2 「화면 이동」). 질의는 ?q= 로 온다.
      { path: 'project/search',   element: <ProjectNavShell><ProjectSearchPage /></ProjectNavShell> },
      /*
       * ⭐⭐ 2026-10-08 — 프로젝트 메뉴 v2(정본 `feature/dev-syk`)에만 «있는» 주소 ★ 둘.
       *   ⇒ 깃발 `PROJECT_V2` 가 꺼지면 ⇒ ⭐ ProjectV2Route 가 «프로젝트 홈으로 되돌린다»
       *     (⛔ 404 가 아니다 — 머지되면 그 주소는 ★ 운영에 «존재»하고, 실은 「아직 안 켠 길」이다).
       *   ⇒ ⚠ 1차는 ★ «뼈대»라 ⇒ 켜져도 ⭐ 아직 아무것도 안 그린다. 화면은 ★ 2차가 자식으로 넣는다.
       * ⚠ `ProjectNavShell` 로 ★ 감싼 까닭: 이 레포의 가드가 ⭐ 「project/… 는 «전부» 감싸인다」를
       *   단언한다(ProjectNavShell.test.tsx). ⇒ ★ 안 감싸면 ⛔ 그 가드가 빨개지고,
       *   ⇒ ⇒ 2차의 화면도 ★ 어차피 그 메뉴를 쓴다. ⇒ ⚠ 꺼진 동안 그 셸이 팀 목록을 한 번 부르는데,
       *      ⇒ ★ 그 주소로 오는 길이 ⭐ «0곳»이라(아무도 링크하지 않는다) 실제로는 안 일어난다.
       */
      /*
       * ⭐ 2026-10-08 (2차 2-2′) — ★ 이 «한 줄»만 바뀌었다: 자식을 받는다(2-1′ 과 ⭐ 같은 꼴).
       *   ⇒ ⚠ 지운 줄에 `path:` 가 따라오지만 ★ 주소는 안 사라진다(더한 줄에 ⭐ 같은 값).
       *     ⇒ 가드가 ★ «값 집합»으로 잰다 — checklist-v2.guard.test.tsx ①.
       */
      {
        path: 'project/checklist-templates',
        element: <ProjectNavShell><ProjectV2Route><ChecklistTemplatesV2Page /></ProjectV2Route></ProjectNavShell>,
      },
      /*
       * ⭐ 2026-10-08 (2차 2-1′) — ★ 이 «한 줄»만 바뀌었다: `<ProjectV2Route />` 가 ⇒ 자식을 받는다.
       *   ⇒ ⚠ 한 줄짜리라 ★ 지운 줄에 `path:` 가 ⭐ «따라온다» — 그러나 ★ 주소는 안 사라졌다
       *     (더한 줄에 ★ 같은 `path:` 값이 있다). ⇒ ⭐ 그래서 가드는 ★ «값 집합»으로 잰다
       *     (project-v2-router.guard.test.ts — 「지운 줄의 path: 값 전부가 더한 줄에도 있다」).
       *   ⇒ ⚠ 정본은 페이지 «안»에서 `<ProjectNavShell active="teams">` 로 감쌌다. ⇒ ⛔ 둘 다 못 옮긴다:
       *     ① 페이지 안에서 감싸면 ⇒ ★ 라우터가 이미 감싸므로 ⭐ 네비가 «두 겹»이 된다
       *     ② `active` 는 ★ main 의 셸에 ⭐ «없는 속성»이다(tsc 가 잡았다) — 정본에서 그 값은
       *        ★ 「어느 묶음을 펼쳐 둘까」(`expanded`)를 정하는데, ⇒ ⭐ main 의 셸엔 ★ 그 기능이 없다
       *     ⇒ ⇒ ✅ 그래서 ★ 라우터 쪽 한 겹만 두고 ⇒ ⛔ 없는 속성을 ★ «만들지 않았다»
       *        (main 의 셸을 고치면 ⇒ ★ 넷째 `M` 이고 ⭐ 기존 화면 전부에 닿는다)
       */
      {
        path: 'project/space/:teamId',
        // 2026-10-13 — 깃발 꺼짐이면 홈이 아니라 그 스페이스의 관리 화면으로(SpaceV2Fallback 머리말).
        element: <ProjectNavShell><ProjectV2Route fallback={<SpaceV2Fallback />}><SpaceV2Page /></ProjectV2Route></ProjectNavShell>,
      },
      {
        path: 'reservation',
        element: <ReservationPage />,
        children: [
          { index: true, element: <Navigate to="/reservation/book" replace /> },
          { path: 'book', element: <ReservationBookPage /> },
          { path: 'mine', element: <MyReservationsPage /> },
          // 승인처리는 담당자에게만 메뉴가 보이지만, 직접 진입해도 서버가 담당 자원으로만
          // 목록을 내려주고 승인 API 가 담당 여부를 재검증한다(프론트 가드는 보안 경계 아님).
          { path: 'approvals', element: <ReservationApprovalPage /> },
        ],
      },
      { path: 'workspace', element: <WorkspacePage /> },
      /**
       * 인사 — 좌 트리 + 우 화면 (2026-08-26, 「인사 메뉴 반영」).
       *
       * ★ 화면은 하나도 새로 만들지 않았다. 아래 열둘은 근태 1~6단계에서 만든 **그 화면 그대로**이고
       *   `element` 도 한 글자 안 바뀌었다 — 다만 지금까지 평평하게 놓여 있어 **메뉴가 없었다**
       *   (내 근태 화면 아래 링크 목록으로만 갈 수 있었다). 여기서 부모 `erp/hr` + 자식으로 나눠
       *   `HrShell` 이 좌측 트리를 이고, 주소(`/erp/hr/employees` …)는 **종전과 같다**.
       *
       * ⚠ 급여(`/payroll`)·인사(`/hr`) 의 «복원 금지» 는 그 **옛 경로**에 대한 것이고 지금도 유효하다.
       *   근태가 `/erp/attendance` 로 열린 것과 같은 규칙으로, 인사는 `/erp/hr` 이라는 **새 경로**다.
       *
       * ★ 2026-08-26 — **셸에는 가드를 두지 않는다.** 직원도 이 메뉴로 «내 인사» 를 보기 때문이다
       *   (트리는 `HrShell` 이 역할에 따라 갈라 그린다). 담당자 화면은 자식마다 RoleGuard 가
       *   그대로 있어, 직원이 주소로 들어오면 대시보드로 돌아간다.
       *   프론트 가드는 UX 게이트이며 권위 있는 차단은 서버가 한다.
       */
      {
        path: 'erp/hr',
        element: <HrShell />,
        children: [
          // 착지 화면 — 보는 사람에 따라 갈라진다(담당자 현황 · 내 인사).
          { index: true, element: <HrIndex /> },
          // 인사 통계 (2026-08-27, 시안 A18) — 새 표도 새 서버 라우트도 없다. 담당자가 이미
          //   부르는 응답 넷(명부·연차 현황·대표/부서장·퇴사 기록)을 `lib/hr-stats.ts` 가 센다.
          { path: 'stats', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><HrStatsPage /></RoleGuard> },
          // 인사기록 › 경력·학력 (2026-08-27, 시안 A19 · migration 132) — 왼쪽 사람, 오른쪽 이력.
          //   읽기는 본인도 되지만(서버), 이 화면은 **담당자의 것**이다(«내 인사기록카드» 는 따로).
          { path: 'records/career', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><RecordsPage /></RoleGuard> },
          // 인사기록 › 포상·징계 (2026-08-27, 시안 A20 · migration 133) — 포상과 징계가 한 목록이다.
          //   징계는 기간이 지나면 말소되므로 «말소 예정» 을 목록에서 바로 보인다.
          { path: 'records/awards', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><AwardsPage /></RoleGuard> },
          // 인사평가 (2026-08-27, 시안 A21 · migration 134) — 왼쪽은 회차, 오른쪽은 진행률과 대상자.
          //   담당자가 보는 것은 점수가 아니라 «누가 아직 안 냈는가» 라 미제출을 맨 앞에 세운다.
          { path: 'evaluations', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><EvaluationsPage /></RoleGuard> },
          // 교육·자격·어학 (2026-08-27, 시안 A22 · migration 135) — 세 탭을 한 화면으로.
          //   담당자에게 이 셋은 같은 일 — 기한이 있는 것을 놓치지 않는 일이다.
          { path: 'records/training', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><TrainingsPage /></RoleGuard> },
          // 내 휴가 · 출장 · 잔업 (2026-08-26) — 전 직원이 들어오는 읽기 화면.
          //   문구(ko/en/ja)는 보존해 둔 `HRPage` 의 것을 그대로 쓰고, 그림만 셸의 언어로 다시 그렸다.
          //   옛 경로 `/hr` 은 여전히 열지 않는다 — 근태가 `/erp/attendance` 로 열린 것과 같은 규칙이다.
          // 내 인사기록카드 (2026-08-27, 시안 B2) — **새 표도 새 라우트도 없다**(발령 본인용 하나만).
          //   A19~A22 를 만들 때마다 읽기를 «본인도» 로 열어 둔 자리를 탭으로 세운 것이 전부다.
          //   전 직원이 들어오는 읽기 화면이라 RoleGuard 를 두지 않는다.
          { path: 'me/record', element: <MyRecordCardPage /> },
          // 정정 요청 처리 (2026-08-27, migration 136) — B2 가 올린 요청을 담당자가 본다.
          //   ★ 승인해도 값은 안 바뀐다 — 명부·발령에서 처리한다(화면이 그렇게 말한다).
          { path: 'profile-requests', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><ProfileRequestsPage /></RoleGuard> },
          // 직위 · 직급 마스터 (2026-08-27, migration 138) — m118 이 정하지 않은 «레벨의 뜻» 을
          //   여기서 정한다(클수록 높다). 목록 밖 직위와 안 맞는 레벨을 담당자가 정리한다.
          { path: 'job-grades', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><JobGradesPage /></RoleGuard> },
          // 직책 — 직위·직급과 «다른 화면»이다(한 화면에 섞으면 다시 position 으로 뭉개진다).
          { path: 'job-roles', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><JobRolesPage /></RoleGuard> },
          // 기준 설정 (2026-08-28, 판 7) — **가드가 없다**: 읽기는 전 직원(신청 화면의 선택지라
          //   못 읽으면 고를 수 없다), 쓰기만 담당자다. 「고칠 수 있는가」는 서버가 판정한다(403).
          { path: 'codes', element: <HrCodesPage /> },
          // 개인정보 열람 이력 (2026-08-28, 자리 재정의 판 3) — **가드가 없다**: 「전사를 보는가」는
          //   서버가 판정한다(403 이면 화면이 «담당자만» 이라고 말하고 접힌다). 라우터는 그것을 모른다.
          { path: 'access-log', element: <AccessLogPage /> },
          /**
           * ★ 「내 휴가 · 출장 · 잔업」과 「내 임금 · 가산 시간」은 **근태 셸로 옮겼다**
           *   (2026-08-29 · 판 C). 둘 다 «내 시간»에 관한 것이라 인사가 아니라 근태다.
           *   옛 주소는 이 셸 **밖**에서 되돌린다(판 B 와 같은 규칙).
           */
          // 부서원 인사정보 (2026-08-27, 시안 B10) — **가드가 없다**: 팀장인지는
          //   서버가 판정한다(403 이면 화면이 스스로 접힌다). 팀장 여부는 라우터가 모른다.
          { path: 'me/team-hr', element: <TeamHrPage /> },
          // 증명서 (인사, migration 129) — 신청은 **전 직원**, 발급함은 회사 관리자.
          //   재직증명서는 서버가 신청과 동시에 발급한다(사람을 거칠 이유가 없다).
          { path: 'me/certificates', element: <MyCertificatePage /> },
          { path: 'certificates', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><CertificateAdminPage /></RoleGuard> },
          // 인사발령 (인사, migration 130) — 등록은 «예정», 시행일에 담당자가 누른다(자동 시행 없음).
          { path: 'assignments', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><AssignmentPage /></RoleGuard> },
          // 퇴사 처리 (인사, migration 131) — 목록을 채우고, 재직 상태는 퇴직 발령이 바꾼다.
          { path: 'offboarding', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><OffboardingPage /></RoleGuard> },
          /**
           * ★ 근태 관리 다섯(입사일 · 연차 · 근무제 · 회사 일정 · 연장 정산)은
           *   **근태 셸로 옮겼다** (2026-08-29 · 판 B). 옛 주소는 이 셸 **밖**에서 되돌린다
           *   — 여기(자식)에 두면 인사 트리를 인 채로 넘어가 한 순간 번쩍인다.
           */
          // 근태 3단계 — 직원 관리·입사 처리. 인사와 계정을 한 화면에서 보되 칸의 주인은 서버가 정한다.
          // 직원 관리 (2026-08-27) — «직원 명부»·«사용자 관리» 를 합친 화면.
          //   ★ 옛 둘은 **그대로 둔다**: `employees` 는 근태 메뉴가 아직 가리키고,
          //     `users` 는 관리 콘솔과 화면 본체를 공유한다. 지우면 그쪽이 깨진다.
          { path: 'staff', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><StaffPage /></RoleGuard> },
          /**
           * ★★ 인사 사람 한 장 (2026-08-30 · 판 B2) — 담당자가 보는 한 사람의 전부.
           *
           * ★ **가드를 두지 않는다.** 범위 판정은 **서버가 한다**(`GET /hr/people/:id` 의 `scope`) —
           *   팀장은 역할이 STAFF 라 `RoleGuard` 로 가리면 자기 팀원도 못 본다. 화면은 온 것만 그린다.
           */
          { path: 'staff/:userId', element: <StaffCardPage /> },
          /*
           * 직원 명부 개편 (2026-09-13 · H · 사용자 확인) — 목록 → 상세는 **화면 이동**(별도 라우트).
           *   `new` 를 `:userId` 보다 먼저 둔다(글자 경로가 이긴다). 종전 한 화면 명부는 `legacy` 로 그대로 남긴다 —
           *   렌더 경로를 부수지 않는다(작업 규칙 · additive).
           */
          // ★ 2026-09-14 — 가드를 `HrGrantGuard` 로 바꿨다: 회사 관리자 · 시스템관리자 + **인사 메뉴를 명시적으로 받은 사람**.
          //   서버가 이 API 들을 `isHrAdminOrGranted(auth, 'hr')` 로 여는데(판 5) 라우터가 역할만 봐 인사 담당자(STAFF)를 돌려보냈다.
          { path: 'employees', element: <HrGrantGuard><EmployeesListPage /></HrGrantGuard> },
          { path: 'employees/new', element: <HrGrantGuard><EmployeeHirePage /></HrGrantGuard> },
          { path: 'employees/legacy', element: <HrGrantGuard><EmployeesPage /></HrGrantGuard> },
          { path: 'employees/:userId', element: <HrGrantGuard><EmployeeDetailPage /></HrGrantGuard> },
          // 인사카드(인쇄용) — 2026-09-13 과제 J · 계약 §18.7
          { path: 'employees/:userId/card', element: <HrGrantGuard><EmployeeCardPage /></HrGrantGuard> },
          // 근태 › 사용자 관리 (2026-08-25) — 관리 콘솔의 같은 화면을 복사했다. 직원 관리(위)가
          //   "보여만 주던" 계정 칸(이메일·사번·권한·비밀번호)을 여기서 고친다. 서버 라우트는
          //   콘솔이 쓰던 것 그대로라 서버·마이그레이션 변경이 없다.
          { path: 'users', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><UserManagePage /></RoleGuard> },
          // 대표·부서장 지정(화면 S). ⚠ 2026-09-04(판 P1)부터 **결재 재료가 아니다** —
          //    여기서 정한 사람은 「우리 조직」 범위·업무보고 자격을 갖는다.
          { path: 'org-leaders', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><OrgLeaderPage /></RoleGuard> },
          // 담당자 관리 (근태 C1) — **부여는 여기 한 곳에서만** 한다. 콘솔은 보기만.
          { path: 'duties', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><DutyPage /></RoleGuard> },
          // 결재선 규칙 — 문서 종류 레지스트리 (결재 A1). 회사 관리자만.
          { path: 'doc-types', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><DocTypePage /></RoleGuard> },
        ],
      },
      { path: 'info',      element: <BoardPage /> },
      // 게시판 시안 v1 (2026-09-15) — `VITE_BOARD_V1='1'` 일 때만 화면별 주소가 선다. 꺼져 있으면 아래 종전 줄 그대로.
      BOARD_V1_ENABLED ? boardV1Route : { path: 'board',     element: <BoardsPageSwitch /> },
      // 급여/인사 라우트 의도적 비노출 (사용자 결정 — NavBar.tsx 주석 참조).
      // 페이지 컴포넌트(PayrollPage/HRPage)·백엔드 라우트/모델은 보존, 메뉴+라우트만 미등록.
      // (조직도는 2026-07-24, 전자결재는 2026-08-24 에 각각 노출로 바뀌었다.)
      // ★ 2026-09-13 — **사용자 결정으로 급여(/payroll)를 복원한다**(관제 경유).
      //   사용자 원문: 「급여 메뉴도 복원해줘」(2026-09-13 · 관제가 전달, 리뷰가 관제에 원문 확인).
      //   ↑ 원문을 남기는 이유 — 아래 금지가 경계한 것이 «근거를 확인할 수 없는 복원» 이었다. 위 비노출 기록은
      //   «왜 닫혀 있었나» 의 이력으로 남기고 지우지 않는다. 이제 닫힌 것은 옛 인사 경로 `/hr`
      //   (HRPage) 하나뿐이다 — 인사 기능 자체는 2026-08-26 에 `/erp/hr`(HrShell)로 이미 열렸다.
      //   ⚠ 화면·백엔드는 처음부터 살아 있었다. 전자결재(2026-08-24)와 같은 부류로 **라우트 등록만**
      //     빠져 있었다. 실측(2026-09-13): `GET /api/v1/payroll/statements` → 200 `{"items":[]}`.
      { path: 'payroll',   element: <PayrollPage /> },
      // 내 프로필(/me) = 프로필 설정 전용 화면(design-20260606 §17.4). 메뉴 진입점.
      // /settings = 기존 전체 설정(환경/알림/외부연동) 보존 — 메뉴엔 미노출이나 URL 접근 가능.
      // (테마/언어/알림은 P3/P4 에서 /me 로 합류 예정. 그동안 회귀 방지 위해 /settings 유지.)
      { path: 'me',        element: <MyProfileMoved /> },
      { path: 'settings',  element: <SettingsPage /> },
      // 사업장 상세 · 추가(`new`) — 목록(`/settings?pane=worksite`) 행을 누르면 온다. 가드는 /settings 와 같다(역할로 가른다).
      { path: 'settings/worksites/:worksiteId', element: <WorksiteDetailRoute /> },
      // 2026-07-24 — 사용자 지시로 조직도 노출 전환(좌측 바 하단 메뉴).
      // 2026-08-24 — 결정 ① 로 **전자결재도 연다**(아래). 위 '복원 금지' 주석이 남는 것은
      // 급여(/payroll)·인사(/hr) 둘뿐이다.
      { path: 'organization', element: <OrganizationPage /> },
      // 전자결재 — 근태의 휴가·연장·정정·외근·출장이 전부 여기를 탄다. 지출결의서·품의서도
      // 같은 자격의 문서 종류다(제안 4). 전 직원이 들어온다(결재 대상은 서버가 가른다).
      /**
       * 전자결재 셸 (2026-08-31 · 시안 F1·F2·F3) — 좌 240px 트리 + 우 화면.
       *
       * ★★ **주소가 처음 생긴다.** 종전에는 `/approval` 하나뿐이라 「결재 대기」도 「양식 · 서식」도
       *    북마크할 수 없었고, 시안이 적어 둔 주소(`/approval/admin/forms` …)가 아무 데도 없었다.
       * ★ 셸에 가드를 두지 않는다 — **전 직원이 결재에 들어온다**(기안하고 참조를 받는다).
       *   담당자 화면은 저마다 **서버가** 403 으로 막고, 트리는 관리자에게만 그 묶음을 세운다.
       *   가드를 라우트에 두면 직접 주소로 들어온 사람이 «권한 없음» 대신 흰 화면을 본다.
       * ★ 「서명 · 도장」은 주소가 없다 — 프로필의 「내 서명」과 **같은 창**을 연다(두 벌 금지).
       */
      /**
       * 대표 업무보고 (2026-09-01 · 파이프라인 하네스 판 I-2).
       *
       * ★ 주소는 `/briefing` 이다 — `exec` 는 개발자에게 **실행(execute)** 으로 읽혀 바꿨다
       *   (2026-09-01 사용자 지시). `report` 는 업무 보고 문서와 헷갈려 쓰지 않았다.
       * ★★ **주소로만 들어간다.** 좌측 레일 메뉴의 실노출 SSOT 는 `admin_menu_registry`(DB)라
       *    코드에서 세우면 fallback 에만 뜬다 — **화면이 먼저, 메뉴는 그 다음**이라는 이 레포의
       *    순서를 따른다(전자결재 `/approval` 이 그렇게 열렸다).
       * ★ **가드를 두지 않는다.** 판정은 서버가 한다(대표 또는 관리자) — 프론트 가드를 두면
       *   대표가 관리자 역할이 아닐 때 정작 볼 사람이 흰 화면을 본다.
       */
      { path: 'briefing', element: <BriefingPage /> },
      {
        path: 'approval',
        element: <ApprShell />,
        children: [
          // 착지 화면 — 들어오면 「지금 무엇을 할까」가 먼저 보인다(판 6 · 시안 F5).
          { index: true, element: <ApprovalHome /> },
          /**
           * 결재함 (2026-09-13 · 과제 L1 · 사용자 확인 시안) — 함 넷을 한 화면 트리로 모은 목록. `?box=` 로 마디를 고른다.
           * ★ 행을 누르면 `doc/:id` 로 간다 · 옛 문서함 넷은 L2 에서 여기로 넘긴다(그때까지 그대로).
           */
          { path: 'box', element: <ApprovalBoxPage /> },
          /**
           * 기안 (2026-08-31) — 종전에는 **560px 모달**이었다. 서식이 칸을 마흔까지 갖는데
           * 그 창에서는 표 한 장도 못 그린다 — 그래서 셸 안의 **제 자리**로 나왔다.
           */
          { path: 'new', element: <ApprovalNewPage /> },
          // 문서함 셋. 제목은 **메뉴 이름과 같다**(`lib/appr-menu.test.ts` 가 못 박는다).
          { path: 'legacy/pending', element: <ApprovalDocsPage view="incoming" title="결재 대기" /> },
          { path: 'legacy/drafts', element: <ApprovalDocsPage view="drafted" title="기안 문서함" /> },
          /**
           * 임시 (2026-09-04 · 판 P2) — **아직 아무에게도 안 간 문서**.
           * ★ 주소를 `drafts` 와 헷갈리지 않게 `temp` 로 둔다(둘은 다른 함이다).
           */
          { path: 'legacy/temp', element: <ApprovalDocsPage view="draft" title="임시" /> },
          // 참고 · 열람 (2026-08-31 신설 · 이름 2026-09-25) — 참고자 줄은 migration 120 부터 쌓였는데 열 자리가 없었다.
          { path: 'legacy/referenced', element: <ApprovalDocsPage view="referenced" title="참고 · 열람" /> },
          /**
           * ★★ 옛 문서함 넷 (2026-09-13 · 과제 L2 · 사용자 결정) — 결재함(`box`)의 마디로 들어왔다.
           *    옛 주소(북마크 · 대시보드 · 기안 뒤 이동)는 그 마디로 넘긴다 — 부르는 쪽은 고치지 않는다.
           * ★ 옛 두 열 화면은 위 `legacy/*` 로 그대로 남긴다(회귀 대비 · 메뉴에는 없다).
           */
          ...Object.entries(LEGACY_BOX_REDIRECTS).map(([from, box]) => ({ path: from, element: <LegacyBoxRedirect box={box} /> })),
          /**
           * 문서 하나 (2026-09-07 · 시안 A2) — **결재 홈에서 줄을 고르면 오는 자리**.
           *
           * ★ 문서함은 왼쪽 목록·오른쪽 상세 두 열이라 그 안에 머문다. 홈에는 목록이 셋이라
           *   그 방식이 안 맞아 주소를 하나 낸다(사용자 지정: 「선택하면 상세 페이지로 이동」).
           * ★ 상세 «내용»은 같은 컴포넌트를 쓴다 — 두 벌로 만들면 한쪽만 고쳐지는 날이 온다.
           */
          { path: 'doc/:id', element: <ApprovalDocPage /> },
          /**
           * 내 지출결의 (2026-09-04 · 예산 판 B1) — 지출결의서 결재의 «뒤».
           * ★ 회사 전체는 **다른 주소**다(`admin/expense`) — 한 화면이 두 자격을 겸하면
           *   서버에 「나는 누구냐」를 찔러 묻게 된다.
           */
          { path: 'expense', element: <MyExpenseClaimsPage /> },
          // ── 관리 · 담당자 — 가드는 **서버**다(화면이 「회사 관리자만」이라 말한다).
          { path: 'admin/stats', element: <ApprovalStatsPage /> },
          { path: 'admin/forms', element: <DocTypePage /> },
          // 결재함 (2026-09-07) — 양식의 묶음. 가드는 **서버**다(화면이 「회사 관리자만」이라 말한다).
          { path: 'admin/boxes', element: <ApprovalBoxesPage /> },
          { path: 'admin/lines', element: <ApprovalLinesAdmin /> },
          // 회사 전체 위임 — 관리자가 아니면 서버가 조용히 «내 것»으로 내려 준다(403 을 안 만든다).
          { path: 'admin/delegates', element: <DelegatePage scope="company" /> },
          { path: 'admin/codes', element: <ApprovalCodesPage /> },
          // 회사 전체 지출 집행 — 계정과목별 집계. 서버가 관리자만 통과시킨다.
          { path: 'admin/expense', element: <CompanyExpenseClaimsPage /> },
          // 예산 편성 (판 B2) — 계정과목 · 지출 집행 옆이 제자리다.
          { path: 'admin/budget', element: <BudgetPage /> },
          // ── 개인 설정 — 내가 맡기는 것. 누구나 쓴다.
          { path: 'me/delegates', element: <DelegatePage /> },
        ],
      },
      // AI 회의록 (additive 라우트) — 메뉴는 /menu-config 동적 노출.
      { path: 'ai-minutes', element: <AiMinutesPage /> },
      /**
       * 근태 셸 (2026-08-29 · 판 A) — **주소는 한 자도 안 바뀐다.**
       *   `/erp/attendance` · `/erp/attendance/codes` · `/erp/attendance/team` 그대로이고,
       *   부모 `erp/attendance`(셸) + 자식으로 나뉘었을 뿐이다. 자식 element 도 종전과 같다.
       *
       * ★★ 왜 셸을 세우나 — 근태에는 **트리를 인 라우트가 없었다.** 그래서 「근태 관리」라는
       *    묶음을 담을 그릇이 없어, 관리 화면들이 「내 근태」 본문 안 카드 묶음이 됐다.
       * ★ 셸에 가드를 두지 않는다 — 두면 직원이 「내 근태」에도 못 들어온다. 자식이 저마다
       *   제 가드를 갖고, 팀 근태는 **서버가** 판정한다(팀장은 역할이 STAFF 라 RoleGuard 밖).
       */
      {
        path: 'erp/attendance',
        element: <AttShell />,
        children: [
          // 내 근태 — 전 직원. 출퇴근은 사실 기록이라 권한 가드가 없다(본인 것만 보고 찍는다).
          { index: true, element: <MyAttendancePage /> },
          // 근태 › 기준 설정 (2026-08-28, 판 7) — 휴가 종류·출장 종류. 가드 없음(위와 같은 이유).
          { path: 'codes', element: <AttendanceCodesPage /> },
          // 팀 근태 — 권한 판정은 **서버가 한다**(팀장 또는 회사 관리자). 팀장은 역할이 STAFF 라
          // RoleGuard 로는 가릴 수 없다 — 화면은 403 을 받아 그 사실을 말한다.
          /**
           * ★★★ **주소가 곧 자격이다** (2026-08-31 · 사용자 결정) —
           *    `team` = 맡은 조직(대표·부서장·팀장) · `company` = 근태 관리(경영·인사 담당).
           *    종전에는 두 메뉴가 같은 주소라 화면이 「나는 어느 자격인가」를 **서버에 찔러**
           *    물어야 했고, 팀장이 열 때마다 403 이 셋씩 남았다.
           */
          { path: 'team', element: <TeamAttendancePage mode="lead" /> },
          { path: 'company', element: <TeamAttendancePage mode="company" /> },
          // 이상 근태 (2026-08-29 · 판 F) — 권한은 **서버가** 판정한다(전사를 보는 사람만).
          //   화면이 403 을 받아 그 사실을 말하므로 RoleGuard 를 두지 않는다.
          { path: 'anomalies', element: <AnomaliesPage /> },
          /**
           * ★★ 근태 관리 다섯 (2026-08-29 · 판 B) — **인사 셸에서 이리로 이사했다.**
           *    가드는 **종전 그대로**(ADMIN·SYSTEM_ADMIN) 옮기기만 한다 — 자리 이사와 권한
           *    확대를 같은 판에 섞으면 무엇이 깨졌는지 못 가린다. 컴포넌트도 한 줄 안 고쳤다.
           */
          // 근태 0단계 — 입사일과 연차. 담당자 부여(3단계) 전까지는 회사 관리자가 겸직한다
          // (2026-08-23 결정 ⑦). 서버도 같은 판정을 한다(403).
          { path: 'hire-dates', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><HireDatesPage /></RoleGuard> },
          { path: 'leave', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><LeaveQuotaPage /></RoleGuard> },
          // 연차정책 (2026-08-30 · 판 J) — 서버도 같은 판정을 한다(403).
          { path: 'leave-policy', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><LeavePolicyPage /></RoleGuard> },
          // 연차촉진 (2026-08-30 · 판 J) — 근기법 §61. 연차정책 옆자리다.
          { path: 'leave-promotion', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><LeavePromotionPage /></RoleGuard> },
          // 퇴사 정산 (2026-08-30 · 판 J) — 미사용 연차를 급여로 넘긴다.
          { path: 'leave-settlement', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><LeaveSettlementPage /></RoleGuard> },
          // 교대 편성 (2026-08-30 · 판 K) — 교대 근무제를 만든 회사에만 트리에 뜬다(파생).
          { path: 'shifts', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><ShiftRosterPage /></RoleGuard> },
          // 근태 2단계 — 근무제·배정. 여기서 정한 시업 시각이 곧 지각 기준이 된다.
          { path: 'work-schedules', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><WorkSchedulePage /></RoleGuard> },
          // 근태 4단계 — 회사 일정(공휴일 두 층). 전역 목록을 지우지 않고 회사 줄을 쌓는다.
          { path: 'holidays', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><CompanyHolidayPage /></RoleGuard> },
          // 근태 6단계(E2) — 연장 정산·임금 프로필(화면 Q). 금액은 **예상**이고 급여 명세는 만들지 않는다.
          { path: 'wages', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><WagePage /></RoleGuard> },
          /**
           * 휴일대체 (2026-09-06 · 판 B) — 보상휴가 §57 을 **회사가 켜는 자리**.
           * ★ 「연장 정산」 옆자리다 — 같은 시간을 «수당으로 줄지 휴가로 줄지» 이므로.
           *   서버도 같은 판정을 한다(근태 담당자 부여 포함 · 403).
           */
          { path: 'substitute', element: <RoleGuard allow={['ADMIN', 'SYSTEM_ADMIN']}><SubstitutePolicyPage /></RoleGuard> },
          /**
           * ★★★ 개인은 **하나로 합쳤다** (2026-09-03 · 정본 P3-3).
           *
           *    「내 휴가 · 출장 · 잔업」 과 「내 임금 · 가산 시간」 이 같은 한 달을 말하면서
           *    다섯 자리가 겹쳤다 — 가산 시간은 **서버의 같은 함수 하나**를 두 화면이 읽고 있었다.
           *    이제 `me` 하나가 그 둘을 담는다. **직원 화면이라 가드가 없다**(서버가 내 것만 준다).
           * ★★ 옛 주소 둘은 **새 화면으로 넘긴다** — 즐겨찾기 · 알림 딥링크 · 대시보드 위젯에
           *    적힌 주소가 그대로 살아야 한다. 지우는 것이 아니라 넘기는 것이다.
           */
          { path: 'me', element: <MyAttendanceHistoryPage /> },
          { path: 'me/leave', element: <Navigate to="/erp/attendance/me" replace /> },
          { path: 'me/wage', element: <Navigate to="/erp/attendance/me" replace /> },
        ],
      },
      /**
       * ★★ 옛 주소 되돌림 (2026-08-29 · 판 B) — **셸 밖**이라는 것이 요점이다.
       *    인사 셸의 자식으로 두면 인사 트리를 **인 채로** 새 주소로 넘어가 한 순간 번쩍인다.
       *    저장해 둔 링크·대시보드 위젯·문서에 적힌 옛 주소가 그대로 산다.
       */
      { path: 'erp/hr/hire-dates', element: <Navigate to="/erp/attendance/hire-dates" replace /> },
      { path: 'erp/hr/leave', element: <Navigate to="/erp/attendance/leave" replace /> },
      { path: 'erp/hr/work-schedules', element: <Navigate to="/erp/attendance/work-schedules" replace /> },
      { path: 'erp/hr/holidays', element: <Navigate to="/erp/attendance/holidays" replace /> },
      { path: 'erp/hr/wages', element: <Navigate to="/erp/attendance/wages" replace /> },
      // 판 C — 개인 둘. 2026-09-03 에 하나로 합쳐져 **한 번만 넘긴다**(두 번 튕기지 않게).
      { path: 'erp/hr/me/leave', element: <Navigate to="/erp/attendance/me" replace /> },
      { path: 'erp/hr/me/wage', element: <Navigate to="/erp/attendance/me" replace /> },
      /**
       * 결재 위임 (결재 A5) — 누구나 자기 결재를 맡길 수 있다. 권한 판정은 서버가 한다.
       *
       * ★★ **입구를 하나로** (2026-08-28). 지금까지 이 주소는 **셸 없이** 위임 화면만 띄웠다 —
       *    들어온 사람이 결재의 다른 곳으로 갈 길이 없었고, 화면 안의 「결재 위임」과 둘로 갈렸다.
       *    이제 같은 셸을 열고 그 함만 골라 둔다. **주소는 그대로 산다**(북마크가 안 깨진다).
       */
      /**
       * 옛 주소 되돌림 (2026-08-31) — **셸 밖**이라는 것이 요점이다(근태 판 B 와 같은 규칙).
       * 셸의 자식으로 두면 트리를 **인 채로** 새 주소로 넘어가 한 순간 번쩍인다.
       * 저장해 둔 링크·문서에 적힌 `/approval/delegates` 가 그대로 산다.
       */
      { path: 'approval/delegates', element: <Navigate to="/approval/me/delegates" replace /> },
      // admin-console 는 별도 관리 서버(8444)로 분리됨 (adr-20260601-0440).
      // Cycle 6 §4 — service admin. cycle 1-18 항목3 — RoleGuard 로 SYSTEM_ADMIN 만 진입.
      { path: 'system-admin', element: <RoleGuard allow={['SYSTEM_ADMIN']}><SystemAdminPage /></RoleGuard> },
      // Cycle 7 — tenant detail page
      { path: 'system-admin/tenants/:id', element: <RoleGuard allow={['SYSTEM_ADMIN']}><TenantDetailPage /></RoleGuard> },
      // Cycle 10 — audit dashboard
      { path: 'system-admin/audit', element: <RoleGuard allow={['SYSTEM_ADMIN']}><AuditDashboardPage /></RoleGuard> },
      // Cycle 20 — ai-gateway env summary
      { path: 'system-admin/ai-gateway-config', element: <RoleGuard allow={['SYSTEM_ADMIN']}><AiGatewayConfigPage /></RoleGuard> },
      // Cycle 23 — drift opt-out overview
      { path: 'system-admin/drift-opt-outs', element: <RoleGuard allow={['SYSTEM_ADMIN']}><DriftOptOutDashboardPage /></RoleGuard> },
      {
        path: 'help',
        element: <HelpPage />,
        children: [
          // 2026-09-13 — 도움말 홈(D). 레일 「도움말」이 닿는 곳 — 종전엔 `/help` 루트가 빈 화면이었다.
          { index: true, element: <HelpHome /> },
          { path: 'admin/bulk-import', element: <AdminBulkImportHelp /> },
          // 향후 다른 admin 매뉴얼 sub-route 추가 자리 (`bulk-import-admin-help-pages` cycle 후속)
        ],
      },
    ],
  },
], {
  // React Router v6 → v7 future flag — v6.28 console warning 제거.
  // v7 부터 4xx/5xx action 응답 시 loader revalidation 자동 skip 이 기본.
  // 본 앱은 react-router data API (loader/action/fetcher) 미사용 → 동작 영향 0.
  future: {
    v7_skipActionErrorRevalidation: true,
  },
});
